import DialogContent from '@mui/material/DialogContent';
import Note from '@shared/ui/messages/Note';
import starImg from '@shared/assets/emoji/star.svg';
import crownImg from '@shared/assets/emoji/crown.svg';
import { useSelector } from 'react-redux';
import { StartVerificationBtn } from '@widgets/buttons';
import { useTranslation } from 'react-i18next';

export default function PrivateBinsDialog() {
  const { user } = useSelector((state) => state.user);
  const { t } = useTranslation();

  return (
    <DialogContent>
      <div className="privateBinsDialog__types">
        <div className="privateBinsDialog__types-item">
          <img src={starImg} alt="" />
          <div>
            <p className="body-18m">{t('Premium')}</p>
            <p className="secondary-text">500+ {t('private_bins_amount')}</p>
          </div>
        </div>
        <div className="divider"></div>
        <div className="privateBinsDialog__types-item">
          <img src={crownImg} alt="" />
          <div>
            <p className="body-18m">{t('Private client')}</p>
            <p className="secondary-text">1000+ {t('private_bins_amount')}</p>
          </div>
        </div>
      </div>
      <Note type="info" marginTop title={t('why_you_need_private_bins')}>
        <div className="privateBinsDialog__note">
          <p className="fw-500 privateBinsDialog__note-title">
            1. {t('improved_card_approval_rates')}
          </p>
          <ul className="privateBinsDialog__note-list">
            <li>
              {t('public_or_commonly_used_virtual_cards_often_get_flagged')}
            </li>
            <li>
              {t('private_bins_are_less_likely_to_be_flagged_or_blacklisted')}
            </li>
          </ul>
          <p className="fw-500 privateBinsDialog__note-title">
            2. {t('bypass_geolocation_and_country_specific_restrictions')}
          </p>
          <ul className="privateBinsDialog__note-list">
            <li>
              {t(
                'some_offers_ad_accounts_and_payment_methods_are_only_available_in_specific_countries',
              )}
            </li>
            <li>
              {t(
                'private_bins_allow_teams_to_issue_cards_from_specific_regions_helping_them_mimic_local_businesses_and_access_geo_restricted_campaigns',
              )}
            </li>
          </ul>
        </div>
      </Note>
      <Note
        marginTop
        type={user.is_onboarding ? 'info' : 'warning'}
        title={t(user.is_onboarding ? 'Support' : 'verification')}
        content={t(
          user.is_onboarding
            ? 'private_bins_contact_support'
            : 'verification_start_content',
        )}
      >
        <StartVerificationBtn />
      </Note>
    </DialogContent>
  );
}
